export function normalizeRedirectPath(value, fallback = "/projects") {
  if (!value) return fallback;
  if (value.startsWith("http")) return fallback;
  if (value.startsWith("//")) return fallback;
  if (!value.startsWith("/")) return `/${value}`;
  return value;
}

export function buildSignInUrl(redirectTo, options = {}) {
  const base = "/sign-in";
  const safe = normalizeRedirectPath(redirectTo);
  const params = new URLSearchParams();
  if (safe) params.set("redirect", safe);
  if (options?.demo) params.set("demo", "1");
  const query = params.toString();
  return query ? `${base}?${query}` : base;
}
